import { AbstractPmsApiService } from "./abstract.service";
import { ShomoosApiSetting } from "../models";

/**
 * @class ShomoosApiSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ShomoosApiSetting>}
 */
export class ShomoosApiSettingPmsApiService extends AbstractPmsApiService {
  /**
   * @type {string}
   * @protected
   */
  get urlPattern() {
    return "/property-shomoos-setting/:propertyId";
  }

  /**
   * @param {Object.<string, *>} attributes
   * @returns {ShomoosApiSetting}
   * @protected
   */
  newModel(attributes, ...params) {
    return new ShomoosApiSetting(attributes);
  }

  /**
   * @param {Property=} property
   * @returns {Promise.<ShomoosApiSetting>}
   */
  get(property) {
    const url = this.url({ propertyId: property.id });

    return this.http
      .get(url, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }

  wallet(property) {
    const url = this.url({ propertyId: property.id }) + "/wallet";

    return this.http
      .get(url, { headers: this.authHeaders })
      .then(this.getDataExtractor())
      .catch(this.getErrorHandler());
  }

  recharge(property, payment) {
    const url = this.url({ propertyId: property.id }, "/property/:propertyId/shomoos-wallet/recharge");

    return this.http
      .post(url, payment, { headers: this.authHeaders })
      .then(this.getDataExtractor())
      .catch(this.getErrorHandler());
  }

  /**
   * @param {Property} property
   * @param {ShomoosApiSetting} settings
   * @returns {Promise.<ShomoosApiSetting>}
   */
  save(property, settings) {
    const url = this.url({ propertyId: property.id });
    return this.http
      .put(url, settings.toObjectExcept("wallet_balance", "fee_per_transaction"), {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/shomoos-api-setting.service.js